import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as archivedHomeAddressState from '../employee-detail.reducer';
import * as archivedHomeAddressReducer from '../reducers/archived-home-address.reducer';


export const getArchivedHomeAddressSelector = createSelector(
  archivedHomeAddressState.getArchivedHomeAddressState,
  archivedHomeAddressReducer.getPreviousHomeAddress
);
